import styled from '@emotion/styled'
import {
    breakpoint,
    breakpointSwitch,
    calcRem,
    getComponentTheme,
    metrics,
    ThemeMargins,
    TheNightlyThemeConfig,
} from '../__styling'
import { textMixin } from '../mixins/TextMixin/TextMixin'

export const StyledVerticalVideoHub = styled('div')<{
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
    verticalSpacing?: keyof ThemeMargins
}>(({ theme, verticalGutters, verticalSpacing }) => {
    const margins = metrics[theme.kind].margins
    return {
        position: 'relative',
        width: '100%',
        marginTop: verticalSpacing && calcRem(margins[verticalSpacing]),
        marginBottom: verticalSpacing && calcRem(margins[verticalSpacing]),
        paddingTop: verticalGutters && calcRem(margins[verticalGutters[0]]),
        paddingBottom: verticalGutters && calcRem(margins[verticalGutters[1]]),
    }
})

export const StyledTheNightlyVerticalVideoHubContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 'auto',
    marginTop: calcRem(40),
    padding: calcRem(0, 24),
    maxWidth: '100%',

    [breakpoint('sm')]: {
        marginTop: calcRem(64),
        padding: 0,
    },
    [breakpoint('lg')]: {
        marginTop: calcRem(80),
        maxWidth: calcRem(770),
    },
})

export const StyledTheNightlyVerticalVideoHubHeader = styled('div')(
    ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        gap: calcRem(theme.margins.md),
        marginBottom: calcRem(theme.margins.sm),

        [breakpoint('sm')]: {
            marginBottom: calcRem(theme.margins.md),
        },
        [breakpoint('lg')]: {
            marginBottom: calcRem(theme.margins.lg),
        },
    }),
)

export const StyledTheNightlyVerticalVideoHubHeaderIcon = styled('div')(
    ({ theme }) => {
        const articleCardsHeaderIcon = getComponentTheme(
            theme,
            'articleCards',
        ).svg

        return breakpointSwitch(
            articleCardsHeaderIcon.breakpointState,
            ({ height, width }) => ({
                height,
                width,
            }),
        )
    },
)

export const StyledTheNightlyVerticalVideoHubHeaderText = styled('h2')(
    ({ theme }) => {
        const articleCardsHeaderTextTheme = getComponentTheme(
            theme,
            'articleCards',
        ).headerText

        return [
            {
                margin: 0,
                fontWeight: 700,
                fontFamily: textMixin<TheNightlyThemeConfig>(
                    theme,
                    'section-header',
                ).fontFamily,
            },
            breakpointSwitch(
                articleCardsHeaderTextTheme.breakpointState,
                ({ fontSize, letterSpacing, lineHeight, color }) => ({
                    fontSize,
                    letterSpacing,
                    lineHeight,
                }),
            ),
        ]
    },
)
